import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { getUser } from '@portal-workspace/grow-ui-library';
import { navigationUrlForNewApplication } from '../service/navigation-urls';
import { DynabotService } from '../service/dynabot.service';

// Admins only, and only while the dynabot feature flag is enabled for them.
export const dynabotKnowledgeAccessGuard = (): CanActivateFn => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const dynabotService = inject(DynabotService);
    if (!getUser()?.priviledges.includes('admin')) {
      return router.createUrlTree(navigationUrlForNewApplication());
    }
    return dynabotService.isDynabotEnabled().pipe(
      map(enabled => enabled || router.createUrlTree(navigationUrlForNewApplication())),
    );
  };
};
